<template>
  <v-card v-resize="onResize">
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Consortia
      </v-toolbar-title>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        label="Search Consortia"
        prepend-icon="mdi-magnify"
        v-on:keyup="searchConsortia"
        clearable
        @click:clear="clearMessage"
        hide-details
      />
    </v-app-bar>

    <v-sheet
      v-resize="onResize"
      :height="height"
      id="scrolling-techniques-7"
      class="overflow-y-auto"
    >
      <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
        <v-card>
          <v-virtual-scroll
            :bench="benched"
            :items="showConsortia"
            :height="height - 80"
            item-height="64"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn v-if="item.active" icon :to="`consortium/${item.id}`">
                    <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn
                    v-else
                    depressed
                    class="red lighten-1"
                    dark
                    @click="consortiumStatus(item.id, true)"
                  >
                    Inactive
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-container>
    </v-sheet>

    <Consortiumform
      :visible="showConsortiumform"
      :item="consortium"
      @close="closeThis"
    />

    <v-btn
      class="mx-2"
      fab
      dark
      absolute
      right
      color="indigo"
      style="bottom: 10px;"
      @click="newConsortium()"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import Consortiumform from '../components/forms/Consortium.vue'

import _ from 'lodash'
import Api from '@/services/Api'

export default {
  name: 'consortia',

  components: {
    Consortiumform,
  },

  data: () => ({
    benched: 0,
    consortia: [],
    consortium: {},
    disable: true,
    height: 400,
    indeterminate: false,
    loading: true,
    logo: '',
    menu: false,
    search: '',
    selectAll: false,
    selected: [],
    showConsortia: [],
    showConsortiumform: false,
    snackbar: {
      show: false,
      color: '',
      message: '',
    },
  }),

  created() {
    this.getConsortia()
  },

  mounted() {
    this.onResize()
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 120
    },

    async getConsortia() {
      const clientId = this.$store.state.client.id

      try {
        const response = await Api().get('consortia/' + clientId)

        const consortia = response.data

        this.consortia = consortia
        this.showConsortia = consortia
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    newConsortium() {
      this.consortium.active = true
      this.showConsortiumform = true
    },

    closeThis() {
      this.showConsortiumform = false
      this.getConsortia()
      console.log('closing')
    },

    async consortiumStatus(consortiumId, active) {
      try {
        let formData = {}
        formData.active = active

        const response = await Api().put('consortia/' + consortiumId, formData)

        let objIndex = this.showConsortia.findIndex(
          obj => obj.id == consortiumId
        )

        this.showConsortia[objIndex].active = active

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchConsortia() {
      this.loading = true

      if (this.search) {
        if (this.search.length > 1) {
          let search = this.search.toLowerCase()

          let consortia = _.filter(this.consortia, function(obj) {
            if (obj.name.toLowerCase().indexOf(search) !== -1) {
              return obj.name.toLowerCase().indexOf(search) !== -1
            }
          })

          this.showConsortia = consortia
        }
      } else {
        this.showConsortia = this.consortia
      }

      this.loading = false
    },

    clearMessage() {
      this.search = ''
      this.showConsortia = this.consortia
    },
  },
}
</script>
